module.exports = __webpack_public_path__ + "static/media/starOpenBg.ab09d29a.png";